module.exports = __webpack_public_path__ + "static/media/s29.8b19da63.jpg";